import React, { useEffect, useState } from "react";
import '../../../assets/css/Ucollection.css'
import { useNavigate, Link } from "react-router-dom";
import Logo from "../../../assets/images/bloom.png"; // Logo Image
import home1 from '../../../assets/images/Asset 5.png'
import home2 from '../../../assets/images/Asset 7.png'
import home3 from '../../../assets/images/Asset 6.png'
import home4 from '../../../assets/images/Asset 11.png'
import home5 from '../../../assets/images/Asset 13.png'
import home6 from '../../../assets/images/Asset 9.png'
import home7 from '../../../assets/images/Asset 8.png'
import home8 from '../../../assets/images/Asset 12.png'
import home9 from '../../../assets/images/Asset 10.png'
import Footer from "../../HomeLandingComp/FooterComp/Footer";
import Unavbar from "../../Uwebsite/UnavbarComp/Unavbar";
import bloomdress1 from "../../../assets/images/bloomdress1.png"
import bloomdress2 from "../../../assets/images/bloomdress2.png"
import bloomdress3 from "../../../assets/images/bloomdress3.png"
import bloomdress4 from "../../../assets/images/Bloomdress4.png"
import bloom1 from "../../../assets/images/Bloom1.png";

import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context
import CartSlider from "../../CartSlider/CartSliderBar";
const products = [
    {
        id: 1,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: bloom1,
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "Cotton",
        work: "Printed",
        packContains: "1 Top",
        careInstructions: "Machine wash on a cold setting and air dry",
        images: [bloomdress1, bloomdress2, bloomdress3, bloomdress4],
        // productDetials: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur euismod, nisl eget convallis iaculis, dui arcu tincidunt metus, eget volutpat dui arcu et lorem. Integer ac nulla et sapien sollicitudin convallis. Suspendisse auctor tincidunt augue, a facilisis libero placerat nec. Etiam maximus mollis lectus, at convallis erat volutpat vel. Ut a tristique odio. Nullam et tempor purus, ac pretium sem. Morbi iaculis nibh ut quam rhoncus ultricies. Mauris ut justo vitae sem malesuada feugiat eget ac nunc.",
        // Specifications: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur euismod, nisl eget convallis iaculis, dui arcu tincidunt metus, eget volutpat dui arcu et lorem. Integer ac nulla et sapien sollicitudin convallis. Suspendisse auctor tincidunt augue, a facilisis libero placerat nec. Etiam maximus mollis lectus, at convallis erat volutpat vel. Ut a tristique odio. Nullam et tempor purus, ac pretium sem. Morbi iaculis nibh ut quam rhoncus ultricies. Mauris ut justo vitae sem malesuada feugiat eget ac nunc.",
        // MaterialandCare: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur euismod, nisl eget convallis iaculis, dui arcu tincidunt metus, eget volutpat dui arcu et lorem. Integer ac nulla et sapien sollicitudin convallis. Suspendisse auctor tincidunt augue, a facilisis libero placerat nec. Etiam maximus mollis lectus, at convallis erat volutpat vel. Ut a tristique odio. Nullam et tempor purus, ac pretium sem. Morbi iaculis nibh ut quam rhoncus ultricies. Mauris ut justo vitae sem malesuada feugiat eget ac nunc.",
    },
    {
        id: 2,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },
    {
        id: 3,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },
    {
        id: 4,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },
    {
        id: 5,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },
    {
        id: 6,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },

    {
        id: 7,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },
    {
        id: 8,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    },

    {
        id: 9,
        name: "Name of Garment",
        price: "Rs. xxxxx",
        image: "https://placehold.co/300x380",
        sizes: ["XS", "S", "M", "L", "XL", "XXL"],
        fabric: "",
        work: "",
        packContains: "",
        careInstructions: "",
        images: ["https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380", "https://placehold.co/300x380"],
    }
];

const BloomCollectionlist = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleProductClick = (product) => {
        navigate(`/bloom/collections/product/${product.id}`, { state: { product } }); // Pass product details to the next page
    };

    const navigate = useNavigate();
     const [cartOpen, setCartOpen] = useState(false); // State to open/close cart
      const { cartItems } = useCart(); // Get cart items from context

    const handleContactClick = (e) => {
        e.preventDefault(); // Prevent default anchor behavior

        navigate("/bloom");

        setTimeout(() => {
            const contactSection = document.getElementById("contact");
            if (contactSection) {
                contactSection.scrollIntoView({ behavior: "smooth" });
            }
        }, 100); // Small delay to ensure navigation happens first
    };
    return (
        <>
            {/* Navbar */}
            <nav className="bloom-navbar">
                <div className="bloom-logo">
                    <Link to="/bloom">
                        <img src={Logo} alt="Bloom Logo" className="bloom-logo-image" />
                    </Link>
                </div>
                <div className="bloom-nav-links">
                    {/* <a href="#home">Home</a> */}
                    <Link to="/bloom">Home</Link>
                    {/* <Link to="/">Home</Link> */}
                    <Link to="/bloom/collections">Collection</Link>
                    <Link onClick={handleContactClick}>Contact Us</Link>
                    {/* Cart Icon */}
                    <div className="cart-container" onClick={() => setCartOpen(true)}>
                        <FaShoppingCart className="cart-icon" />
                        {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
                    </div>
                </div>
            </nav>
            {/* Cart Slider */}
            {cartOpen && <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />}
            <div className="collection-container">
                <h2 className="collection-title">Collection</h2>
                <div className="collection-grid">
                    {products.map((product) => (
                        <div
                            key={product.id}
                            className="collection-item"
                            onClick={() => handleProductClick(product)} // Pass the entire product
                        >
                            <img src={product.image} alt={product.name} className="ucollection-image" />
                            <h3 className="product-name">{product.name}</h3>
                            <p className="product-price">{product.price}</p>
                        </div>
                    ))}
                </div>
                {/* <button className="shop-button">Shop Collection &gt;</button> */}
            </div>
            <Footer />
        </>
    );
};
export default BloomCollectionlist